import { render } from "./SingleAttorney.vue?vue&type=template&id=fdaefaae"
import script from "./SingleAttorney.vue?vue&type=script&lang=js"
export * from "./SingleAttorney.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__